/*
 * @Author: your name
 * @Date: 2021-01-22 13:50:53
 * @LastEditTime: 2021-06-08 13:59:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \code\fe-mall\components\floor-template\i18n.js
 */
export default {
  'zh-CN': {
    cartAddedSuccessfully: '购物车添加成功',
    mallShopping: '商城采购',
    offstorePurchasing: '非商城采购',
    allCategoriesOfGoods: '全部商品分类',
    logOut: '退出登录',
    login: '登录',
    pleaseLogIn: '请登录',
    failedLocate: '定位失败，请手动设置配送区域',
    failedGetLanguageList: '获取用户语言列表失败',
    theShoppingCart: '购物车',
    sceneProcurement: '场景采购',
    points: '分',
    aftersalesTelephone: '售后电话:',
    businessAddress: '经营地址:',
    goods: '商品',
    supplier: '供应商',
    deleteAll: '全部删除',
    createPurchaseRequisitions: '创建采购申请单',
    enterKeyWord: '请输入您要采购的商品关键字',
    enterSupplier: '请输入您要搜索的供应商',
    enterNoMoreThan: '搜索关键词请输入{n}个字符以内！',
    searchInShop: '搜本店',
    seekTotalStation: '搜全站',
    noNeedProduct: '如在商城未找到您需要的商品，您可以通过“非商城采购”提报采购需求。',
    know: '知道了',
    search: '搜索',
    newNotice: '最新通知：',
    no: '暂无',
    scoreTotal: '综合评分：',
    warehouse: '仓库',
    pleaseEnterToSupportFuzzySearch: '请输入，支持模糊搜索',
    address: '地址',
    theQuery: '查询',
    theWarehouseIsOutOfStockAtTheMoment: '仓库暂时无货',
    inventoryOrganization: '库存组织',
    inventory: '库存',
    cancel: '取消',
    determine: '确定',
    chooseTheOldWarehouse: '选择利旧仓库',
    selectTheRequisitionWarehouse: '选择领用仓库',
    pleaseSelectA: '请选择',
    recentlyOftenChoose: '最近常选',
    all: '全部',
    allWarehouse: '全部仓库',
    colonEn: ':',
    helpCenter: '帮助中心',
    addCart: '添加购物车',
    continueToSubmit: '继续提交',
    theGoodsYouAddedInTheMallHaveRequisitionGoods: '您添加的商品在商城中存在领用商品（{link}），存在领用商品的情况下，请优先选择领用商品。是否要继续提交？',
    checkTheMerchandise: '查看领用商品',
    isNotAvailable: '无货',
    received: '待收货',
    allWarehouseOrg: '全部库存组织',
    more: '查看更多',
    stow: '收起'
  },
  en: {
    cartAddedSuccessfully: 'Added to the shopping cart successfully',
    mallShopping: 'Mall Shopping',
    offstorePurchasing: 'Non-mall shopping',
    allCategoriesOfGoods: 'All product category',
    login: 'log in',
    logOut: 'Log out',
    pleaseLogIn: 'Please log in',
    failedLocate: 'Failed to locate. Please manually set the delivery area',
    failedGetLanguageList: 'Failed to obtain user language list',
    theShoppingCart: 'Shopping Cart',
    sceneProcurement: 'Scene procurement',
    points: 'Minute',
    aftersalesTelephone: 'After-sales telephone: ',
    businessAddress: 'Business address: ',
    goods: 'Product',
    supplier: 'Supplier',
    deleteAll: 'Delete all',
    createPurchaseRequisitions: 'Create PR',
    enterKeyWord: 'Please enter the key word of the product you want to purchase',
    enterSupplier: 'Please enter the supplier you want to search',
    enterNoMoreThan: 'Please enter keywords no more than {n} characters!',
    searchInShop: 'Store',
    seekTotalStation: 'Sitewide',
    noNeedProduct: 'If you don\'t find the products you need in the mall, you can submit your purchase request through "Non-mall shopping".',
    know: 'Got it',
    search: 'Search',
    newNotice: 'Latest notifications: ',
    no: 'Not yet',
    scoreTotal: 'Comprehensive score:',
    warehouse: 'Warehouse',
    pleaseEnterToSupportFuzzySearch: 'Please enter. Fuzzy search supported',
    address: 'Address',
    theQuery: 'Query',
    theWarehouseIsOutOfStockAtTheMoment: 'No stock',
    inventoryOrganization: 'Storage organization',
    inventory: 'Inventory',
    cancel: 'Cancel',
    determine: 'Confirm',
    chooseTheOldWarehouse: 'Select warehouse',
    selectTheRequisitionWarehouse: 'Select warehouse',
    pleaseSelectA: 'Please select',
    recentlyOftenChoose: 'Recent',
    all: 'All',
    allWarehouse: 'All warehouse',
    colonEn: ':',
    helpCenter: 'Help center',
    addCart: 'Add to cart',
    continueToSubmit: 'Continue',
    theGoodsYouAddedInTheMallHaveRequisitionGoods: 'The goods you add are available in the mall ({link}). In the case of available goods, please give priority to the selected goods. Do you want to continue with the submission?',
    checkTheMerchandise: 'View lingyong product',
    isNotAvailable: 'No stock',
    received: 'Processed',
    allWarehouseOrg: 'All organization',
    more: 'View More',
    stow: 'Collapse'
  },
  ja: {
  }
}
